import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next"
import Dialog from "../../../../../../components/shared/Dialog";
import ResourceSelect from "../../../../../../components/shared/inputs/ResourceSelect";
import { Label } from "../../../../../../components/ui/label";
import Button from "../../../../../../components/shared/Button";
import { firstToUpper } from "../../../../../../utils/helpers/string";

function LoadTemplates({ visible, close, loading, onFinish }: any) {
    const { t } = useTranslation();
    const [template, setTemplate] = useState<any>();

    useEffect(() => {
        if (!visible) setTemplate(undefined);
    }, [visible]);

    return (
        <Dialog
            open={visible}
            close={close}
            title={t("load-day-template")}
        >
            <Label className="tw-mb-2">
                {firstToUpper(t("template"))}
            </Label>
            <ResourceSelect
                resourcePath="/schedule-templates"
                mode="single"
                placeholder={firstToUpper(t("template"))}
                labelPropName="name"
                value={template}
                onChange={(value: any) => setTemplate(value)}
            />

            <div className="tw-flex tw-items-center tw-justify-end tw-py-2 tw-gap-2">
                <Button
                    type="button"
                    variant="ghost"
                    disabled={loading}
                    onClick={close}
                >
                    {t("cancel")}
                </Button>
                <Button
                    type="button"
                    disabled={!template?.id || loading}
                    loading={loading}
                    onClick={() => onFinish(template?.id)}
                >
                    {t("save")}
                </Button>
            </div>
        </Dialog>
    );
}

export default LoadTemplates;
